export const featureFlags = {
  requestAccess: process.env.REACT_APP_REQUEST_ACCESS_FEATURE || false
};
